import React from 'react';
import PropTypes from 'prop-types';
import { Link, ShareFacebookIcon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';

function SocialShareFacebook({
  url,
  handleSocialLinkClick,
  linkTitle,
  color = grey600,
}) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'facebook')}
      title={linkTitle}
      style={{ color }}
      data-testid="social-share-facebook"
    >
      <ShareFacebookIcon size="lg" />
    </Link>
  );
}

SocialShareFacebook.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareFacebook;
